import React, {Component} from 'react';
import IPost from '../../core/models/post';
import moment from 'moment';
import '../../styles/list-post.scss';

class PostList extends Component < IPost > {
     constructor(props : IPost) {
          super(props);
          this.createMarkup = this
               .createMarkup
               .bind(this);
     }

     public createMarkup(data : any) : any {
          return {__html: data};
     }

     public render() {
          return (
               <div className="col-sm-12 col-md-12 post-item list-item">
                    <div className="col-xs-3 col-md-3">
                         {this.props.data.postMetaFields.images.large?
                         <a href={this.props.data.link}><img
                         className="img-responsive text-center item-image"
                         src={this.props.data.postMetaFields.images.large}
                         alt={this.props.data.title.rendered}/>
                    </a>:null}
                         
                    </div>
                    <div className="col-xs-9 col-md-9">

                         <div className="post-text">
                              <a href={this.props.data.link}>
                                   <strong
                                        className="over-solid"
                                        dangerouslySetInnerHTML={this.createMarkup(this.props.data.title.rendered)}/>
                              </a>
                              <p className="over-solid text-date">{moment(this.props.data.date).format('ll')}</p>
                              <p
                                   className="over-solid text-content"
                                   dangerouslySetInnerHTML={this.createMarkup(this.props.data.excerpt.rendered)}/>
                         </div>
                    </div>
               </div>
          );
     }
}

export default PostList;